import { pipe } from "@uri/gamla";

const linkifyAngleBracketUrls = (raw: string) =>
  raw.replace(/<((https?:\/\/)[^ >]+)>/g, (_m, url: string) => {
    const safeUrl = url.replace(/"/g, "&quot;");
    return `<a href="${safeUrl}" target="_blank" rel="noopener noreferrer">${safeUrl}</a>`;
  });

const escapeNamespaceLikeTags = (raw: string) =>
  raw.replace(
    /<\/?([a-zA-Z][\w.\-]*:[a-zA-Z\w.\-:]*)(?:\s+[^>]*)?\/?>/g,
    (match) => match.replace(/</g, "&lt;").replace(/>/g, "&gt;"),
  );

export const tagFloodThreshold = 30;

const escapeHtml = (s: string) => s.replace(/</g, "&lt;").replace(/>/g, "&gt;");

const collapseTagFloods = (raw: string) =>
  raw.replace(
    /(<\/?[a-zA-Z][\w-]*\s*\/?>)\1{29,}/g,
    (match, tag: string) => {
      const count = match.length / tag.length;
      return `<span class="flood-marker" data-count="${count}">[${
        escapeHtml(tag)
      } ×${count}]</span>`;
    },
  );

export const sanitizeBrokenHtml = pipe(
  collapseTagFloods,
  linkifyAngleBracketUrls,
  escapeNamespaceLikeTags,
);
